// DS: i4.45 Daily Challenge
import React from 'react';
import IconWrap from '../../IconWrap';
const DailyChallenge = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.43 3.44c.03-.27-.17-.41-.44-.44h-1.5a.5.5 0 0 0-.55.44L8.46 7.8h-4.3a.5.5 0 0 0-.5.49v1.5c0 .28.23.5.5.5l4.02.01-.4 3.65-3.62-.01a.5.5 0 0 0-.5.5v1.5c0 .27.22.5.5.5H7.5l-.44 4.12c-.03.27.17.4.45.44H9a.5.5 0 0 0 .55-.44l.46-4.1h3.47l-.43 4.1c-.03.27.17.4.44.44H15a.5.5 0 0 0 .55-.44l.46-4.09 3.84.01a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5h-3.57l.41-3.65h3.16a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5h-2.88l.45-4.39c.04-.27-.16-.41-.44-.44h-1.49a.5.5 0 0 0-.55.44l-.49 4.38h-3.47l.46-4.38Zm-.74 6.87-.4 3.65h3.47l.4-3.64-3.47-.01Z"
    })));
};
DailyChallenge.displayName = 'DailyChallenge';
export default DailyChallenge;
